// Apex Business Intelligence — Round 9 Email Log (admin page)
import React, { useEffect, useState, useCallback } from "react";
import { toast } from "./intelligence";

const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "apex_auth_token";
const auth = () => { const t = localStorage.getItem(TOKEN_KEY); return t ? { Authorization: "Bearer " + t } : {}; };
const j = (path, opts = {}) =>
  fetch(`${API}${path}`, { ...opts, headers: { "Content-Type": "application/json", ...auth(), ...(opts.headers || {}) } })
    .then(async r => { const data = await r.json().catch(() => ({})); if (!r.ok) throw Object.assign(new Error(data.detail || r.statusText), { data, status: r.status }); return data; });

const card = { background: "var(--bg2)", border: "1px solid var(--border)", borderRadius: 8, padding: 18, marginBottom: 14 };
const subhead = { fontFamily: "var(--rajdhani)", fontSize: 14, fontWeight: 700, marginBottom: 10, letterSpacing: 0.5 };
const tableHead = { fontSize: 10, letterSpacing: 1, textTransform: "uppercase", color: "var(--text3)", textAlign: "left", padding: "8px 10px", borderBottom: "1px solid var(--border)" };
const tableCell = { fontSize: 12, padding: "8px 10px", borderBottom: "1px solid var(--border)" };
const inputStyle = { padding: "8px 10px", background: "var(--bg)", border: "1px solid var(--border)", borderRadius: 4, color: "var(--text)", fontSize: 12, fontFamily: "var(--dm)" };
const pill = (bg, text = "#fff") => ({ display: "inline-block", padding: "2px 8px", borderRadius: 999, fontSize: 10, letterSpacing: 0.5, background: bg, color: text });

export function EmailLogPage() {
  const [emails, setEmails] = useState([]);
  const [meta, setMeta] = useState({ templates: [], senders: {}, resend_configured: false });
  const [tplFilter, setTplFilter] = useState("");
  const [okFilter, setOkFilter] = useState("");
  const [q, setQ] = useState("");
  const [detail, setDetail] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    const p = new URLSearchParams();
    if (tplFilter) p.set("template_key", tplFilter);
    if (okFilter) p.set("ok", okFilter);
    if (q) p.set("q", q);
    p.set("limit", "200");
    j(`/api/iv/r9/log?${p.toString()}`).then(d => setEmails(d.emails || [])).catch(e => toast(e.message, "err"));
  }, [tplFilter, okFilter, q]);

  useEffect(() => {
    j("/api/iv/r9/templates").then(setMeta).catch(() => {});
  }, []);
  useEffect(load, [load]);

  const openDetail = async (id) => {
    try {
      const d = await j(`/api/iv/r9/log/${id}`);
      setDetail(d);
    } catch (e) { toast(e.message, "err"); }
  };

  const resend = async (id) => {
    if (!window.confirm("Re-send this exact email (with the same recipient + variables)?")) return;
    setBusy(true);
    try {
      const r = await j(`/api/iv/r9/log/${id}/resend`, { method: "POST" });
      toast(r.ok ? "Re-sent" : (r.reason || "Re-send failed"), r.ok ? "ok" : "err");
      load();
    } catch (e) { toast(e.message, "err"); } finally { setBusy(false); }
  };

  return (
    <div data-testid="r9-email-log-page" style={{ padding: 24 }}>
      <div style={card}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
          <div>
            <div style={subhead}>Email Log</div>
            <div style={{ fontSize: 11, color: "var(--text3)" }}>
              Resend domain · <strong>apexinfinityventures.com</strong> ·
              {meta.resend_configured
                ? <span style={{ color: "#16a34a", marginLeft: 6 }}>● connected</span>
                : <span style={{ color: "#cc0000", marginLeft: 6 }}>● API key missing</span>}
            </div>
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <select data-testid="email-tpl-filter" value={tplFilter} onChange={e => setTplFilter(e.target.value)} style={{ ...inputStyle, width: 200 }}>
              <option value="">All templates</option>
              {(meta.templates || []).map(t => <option key={t.key} value={t.key}>{t.key} · {t.name.replace("t_", "").replace(/_/g, " ")}</option>)}
            </select>
            <select data-testid="email-ok-filter" value={okFilter} onChange={e => setOkFilter(e.target.value)} style={{ ...inputStyle, width: 140 }}>
              <option value="">All statuses</option>
              <option value="true">Delivered</option>
              <option value="false">Failed</option>
            </select>
            <input data-testid="email-search" placeholder="Search to / subject" value={q} onChange={e => setQ(e.target.value)} style={{ ...inputStyle, width: 220 }} />
            <button className="btn btn-ghost" onClick={load} style={{ fontSize: 11 }} data-testid="email-refresh">↻ Refresh</button>
          </div>
        </div>
      </div>

      <div style={card}>
        <div style={subhead}>{emails.length} send{emails.length === 1 ? "" : "s"}</div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={tableHead}>Template</th><th style={tableHead}>To</th>
                <th style={tableHead}>Subject</th><th style={tableHead}>From</th>
                <th style={tableHead}>Status</th><th style={tableHead}>When</th><th style={tableHead}></th>
              </tr>
            </thead>
            <tbody>
              {emails.map(e => (
                <tr key={e.id} data-testid={`email-row-${e.id}`}>
                  <td style={tableCell}><span style={pill("#1d4ed8")}>{e.template_key}</span></td>
                  <td style={tableCell}>{e.to}</td>
                  <td style={tableCell}>{e.subject?.slice(0, 70)}</td>
                  <td style={tableCell}>{e.sender?.email}</td>
                  <td style={tableCell}>
                    {e.ok
                      ? <span style={pill("#16a34a")}>DELIVERED</span>
                      : <span style={pill("#cc0000")}>FAILED</span>}
                  </td>
                  <td style={tableCell}>{(e.ts || "").slice(0, 19).replace("T", " ")}</td>
                  <td style={tableCell}>
                    <button className="btn btn-ghost" onClick={() => openDetail(e.id)} style={{ fontSize: 10 }} data-testid={`email-view-${e.id}`}>View</button>
                    <button className="btn btn-primary" onClick={() => resend(e.id)} disabled={busy} style={{ fontSize: 10, marginLeft: 4 }} data-testid={`email-resend-${e.id}`}>Resend</button>
                  </td>
                </tr>
              ))}
              {!emails.length && (
                <tr><td colSpan={7} style={{ ...tableCell, color: "var(--text3)", textAlign: "center" }}>
                  No emails yet. Triggers will appear here as they fire.
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {detail && (
        <div data-testid="email-detail-modal" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 8000, padding: 24 }}>
          <div style={{ ...card, width: 720, maxHeight: "90vh", overflow: "auto", marginBottom: 0, background: "var(--bg2)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
              <div>
                <div style={subhead}>{detail.template_key} · {detail.subject}</div>
                <div style={{ fontSize: 11, color: "var(--text3)" }}>
                  {detail.sender?.display} &lt;{detail.sender?.email}&gt; → {detail.to}
                  {detail.reply_to && <span> · Reply-To {detail.reply_to}</span>}
                </div>
              </div>
              <button className="btn btn-ghost" onClick={() => setDetail(null)} style={{ fontSize: 12 }} data-testid="email-detail-close">✕</button>
            </div>
            {!detail.ok && (
              <div style={{ background: "#7f1d1d", color: "#fff", padding: 10, borderRadius: 6, fontSize: 12, marginBottom: 10 }}>
                <strong>Failed:</strong> {detail.reason || "Unknown error"}
              </div>
            )}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
              <div>
                <div style={{ fontSize: 10, letterSpacing: 1, textTransform: "uppercase", color: "var(--text3)", marginBottom: 4 }}>Rendered HTML</div>
                <iframe
                  title="email-html-preview"
                  data-testid="email-html-iframe"
                  srcDoc={detail.html_preview || "<em>No preview stored (older email)</em>"}
                  style={{ width: "100%", height: 440, border: "1px solid var(--border)", borderRadius: 6, background: "#fff" }}
                />
              </div>
              <div>
                <div style={{ fontSize: 10, letterSpacing: 1, textTransform: "uppercase", color: "var(--text3)", marginBottom: 4 }}>Plain text</div>
                <pre style={{ background: "var(--bg)", border: "1px solid var(--border)", borderRadius: 6, padding: 10, fontSize: 11, height: 200, overflow: "auto", whiteSpace: "pre-wrap" }}>
{detail.text_preview || "—"}
                </pre>
                <div style={{ fontSize: 10, letterSpacing: 1, textTransform: "uppercase", color: "var(--text3)", margin: "10px 0 4px" }}>Variables</div>
                <pre style={{ background: "var(--bg)", border: "1px solid var(--border)", borderRadius: 6, padding: 10, fontSize: 11, height: 200, overflow: "auto" }}>
{JSON.stringify(detail.vars || {}, null, 2)}
                </pre>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14 }}>
              <button className="btn btn-primary" onClick={() => resend(detail.id)} disabled={busy} style={{ fontSize: 11 }} data-testid="email-detail-resend">
                {busy ? "Re-sending…" : "Re-send to " + detail.to}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
